<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />

      <v-spacer></v-spacer>
      <MgmtButtons
        :view="view"
        :acl="acl"
        :system="item.system"
        @createItem="createItem"
        @deleteItem="deleteItem"
        @toView="toView"
        @toEdit="toEdit"
      />
      </v-row>
      <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <v-tab href="#system" @click="activeTab = 'system'">Системные</v-tab>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="info">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Информация</v-card-title>
                <v-card-text>
                  <table class="view-table" width="100%" >
                    <tr>
                      <th>Название:</th>
                      <td>{{ item.name }}</td>
                    </tr>

                    <tr>
                      <th>Раздел:</th>
                      <td>{{ item.model_name_ru }}</td>
                    </tr>

                    <tr>
                      <th>Ссылка на отчет:</th>
                      <td><router-link :to="{ name: 'custom_report', params: { id: item.id }}">{{ item.name }}</router-link></td>
                    </tr>

                  </table>
                </v-card-text>
              </v-card>

              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Роли пользователя</v-card-title>
                <v-card-text>
                  <table class="view-table" width="100%">
                    <tr>
                      <th class="view-table-list">Роль:</th>
                      <td>
                        <ul class="view-table-list">
                          <li v-for="role in item.roles" :key="role.id"><router-link :to="{ name: 'role_view', params: { id: role.id }}">{{ role.title }}</router-link></li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>

            </v-col>

            <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-title class="primary--text">Поля</v-card-title>
                  <v-treeview
                    v-model="item.model_fields"
                    :items="model_fields"
                    selectable
                    item-disabled="locked"
                    selection-type="leaf"
                    return-object
                    item-text="text"
                    item-key="id"
                    dense
                    class="pb-4"
                  ></v-treeview>
                </v-card>
            </v-col>

          </v-row>
        </v-tab-item>

        <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols125">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-text>
                  <table class="view-table">
                    <tr>
                      <th>Создан:</th>
                      <td>{{ item.created_by_name }}</td>
                    </tr>
                    <tr>
                      <th>Дата создания:</th>
                      <td>{{ item.date_created }}</td>
                    </tr>
                    <tr>
                      <th>Изменен:</th>
                      <td>{{ item.modified_by_name || '---' }}</td>
                    </tr>
                    <tr>
                      <th>Дата изменения:</th>
                      <td>{{ item.date_modified || '---' }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </StaticTabs>
    </v-col>

    <v-col :cols="colsBar">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <RefFilter
          class="user-filter"
          :query="initialQuery"
          :count="count"
          :filterPending="filterPending"
          :countTotal="countTotal"
          @filteredLoad="filteredLoadCollbar"
        />

      </v-row>
      <hr />
      <CollectionBar
        :id="item.id"
        :items="coll"
        :count="count"
        :loading="loadingCollbar"
        :scrollBusy="scrollBusy"
        @loadCollbar="loadCollbar"
        @toEdit="toEdit"
        @toView="toView"
      />
    </v-col>

  </v-row>
  <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  />
</div>
</template>

<script>
import RefFilter from '@/components/filters/RefFilter'
import ViewMixin from '@/views/View.vue'
export default {
  mixins: [ViewMixin],
  components: {
    RefFilter
  },
  computed: {
  },
  data: function () {
    return {
      modelName: 'CustomReport',
      viewName: 'custom_report',
      viewTitle: 'Пользовательские отчеты',

      urlList: 'report/custom_reports/',
      urlObj: 'report/custom_report/',

      parentHref: '#/report/custom_report',

      // item
      item: {
        id: this.id,
        name: '',
        model_name_ru: ''
      },

      model_fields: [],

      items: {
        columns: [],
        roles: [],
        // model_names: [],
        model_names: [
          { name: 'Организации', value: 'Organization', filter_name: 'OrganizationFilter' },
          { name: 'Контрагенты', value: 'Client', filter_name: 'ClientFilter' },
          { name: 'Договор', value: 'Contract', filter_name: 'ContractFilter' },
          { name: 'Объекты охраны', value: 'SecureObject', filter_name: 'SecureObjectFilter' },
          { name: 'Посты', value: 'Post', filter_name: 'PostFilter' },
          { name: 'Мат. ценности', value: 'Inventory', filter_name: 'InventoryFilter' },
          { name: 'Сотрудники', value: 'Unit', filter_name: 'UnitFilter' },
          { name: 'Роли', value: 'Role', filter_name: 'RoleFilter' },
          { name: 'Пользователи', value: 'User', filter_name: 'UserFilter' },
          { name: 'ГБР', value: 'RapidReactionGroup', filter_name: 'GbrFilter' },
          { name: 'Подразделения', value: 'Subdivision', filter_name: 'SubdivisionFilter' },
          { name: 'ОЛРР', value: 'Olrr', filter_name: 'OlrrFilter' },
          { name: 'Журнал событий', value: 'PostEvent', filter_name: 'PostEventFilter' },
          { name: 'Журнал контроля', value: 'PostControl', filter_name: 'PostControlFilter' },
          { name: 'Доклады', value: 'Report', filter_name: 'ReportControlFilter' },
          { name: 'Оповещения', value: 'Alert', filter_name: 'AlertFilter' },
          { name: 'Задачи', value: 'Task', filter_name: 'TaskFilter' },
          { name: 'Фин. заявки', value: 'PayOrder', filter_name: 'PayOrderFilter' },
          { name: 'Тех. обслуживание', value: 'TechService', filter_name: 'TechServiceFilter' },
          { name: 'Правовой центр', value: 'LegalCenter', filter_name: 'LegalCenterFilter' },
          { name: 'Реестр табелей', value: 'SalaryRegister', filter_name: 'SalaryRegiterFilter' },
          { name: 'Мат. обеспечение', value: 'TechEquipment', filter_name: 'TechEquipmentFilter' },
          { name: 'Тендерный центр', value: 'TenderCenter', filter_name: 'TenderCenterFilter' },
        ],
      },

      // collbar
      collbar: {
        url: 'report/custom_reports/',
        name: 'custom_reports'
      },
    }
  },
  methods: {
    externalInit () {
      for (const item of this.items.model_names) {
        if (item.value === this.item.model_name) {
          this.item.model_name_ru = item.name
        }
      }
      this.model_fields = this.item.model_fields.map((item) => { return Object.assign(item, { locked: true }) })
    }
  }
}
</script>
<style>
</style>
